import * as React from "react";
import {VeboxTreeView} from "../VeboxTreeView";
import {VeboxSelectionListActionType} from "../../selection_list/VeboxSelectionList";
import {useValue} from "../../../users/HierarchyVisibilityUtils";


export interface VeboxTreeCheckboxGroupProps {
    onChange?: (values: any | any[]) => void;
    values?: any | any[];
    disabled?: boolean;
}

export const VeboxTreeViewCheckboxGroup: React.FC<VeboxTreeCheckboxGroupProps & React.HTMLAttributes<any>> = ({
                                                                                                                  values,
                                                                                                                  onChange,
                                                                                                                  disabled,
                                                                                                                  className,
                                                                                                                  children,
                                                                                                                  ...rest
                                                                                                              }) => {
    const handleChange = (value, action) => {
        switch (action) {
            case VeboxSelectionListActionType.ADD: {
                const newValues = [...(values ?? []).filter(v => useValue(v) !== useValue(value)), value]
                if (onChange) {
                    onChange(newValues);
                }
                break;
            }
            case VeboxSelectionListActionType.REMOVE: {
                const newValues = (values ?? []).filter(v => useValue(v) !== useValue(value))
                if (onChange) {
                    onChange(newValues);
                }
                break;
            }
        }
    }

    return (
        <VeboxTreeView
            {...rest}
            className={className + (disabled ? " vebox-tree-view-disabled" : "")}
            onChange={undefined}
        >
            {React.Children.toArray(children)
                .filter(Boolean)
                .map((c: any) => React.cloneElement(
                    c,
                    {
                        ...(c ?? {}).props,
                        onChange: handleChange,
                        siblings: values ?? [],
                        level: (rest as any).level,
                        disabled: disabled || c.props.disabled
                    }
                ))
            }
        </VeboxTreeView>
    );
}